import { useState } from "react"
import { Outlet } from "react-router-dom"
import Sidebar from "./Sidebar"
import TopBar from "./TopBar"
import MobileBottomNav from "./MobileBottomNav"
import { useAuth } from "../auth/AuthProvider"

const AppShell = () => {
  const { user } = useAuth()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  return (
    <div className="min-h-screen bg-sand p-3 sm:p-6">
      <div className="mx-auto min-h-[calc(100vh-24px)] max-w-[1920px] rounded-[36px] bg-pearl p-4 sm:p-6 shadow-card">
        <div className="flex h-full gap-4 lg:gap-6">
          {/* Desktop Sidebar */}
          <div className="hidden lg:block">
            <Sidebar />
          </div>

          {/* Mobile Menu Overlay */}
          {isMobileMenuOpen && (
            <div
              className="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm transition-opacity duration-300 lg:hidden"
              onClick={() => setIsMobileMenuOpen(false)}
            />
          )}

          {/* Main Content */}
          <main className="flex-1 space-y-4 sm:space-y-6 pb-20 lg:pb-0">
            <TopBar user={user} />
            <Outlet />
          </main>
        </div>
      </div>

      {/* Mobile Bottom Navigation */}
      <MobileBottomNav
        isMenuOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
        onMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      />
    </div>
  )
}

export default AppShell
